import { push } from 'connected-react-router';
import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getFavoriteDestinations() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_FAVORITE_DESTINATIONS_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.favorite_destination.getFavoriteDestinations();

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_FAVORITE_DESTINATIONS_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
		}

		dispatch({
			type: ActionTypes.GET_FAVORITE_DESTINATIONS_SUCCESS,
			payload: {
				favorite_destinations: response.data.favorite_destinations,
				loading: false
			}
		});
	};
}

export function createFavoriteDestinations(fields) {
	return async (dispatch, getState) => {
		const { favorite_destinations } = getState().favoriteDestinationListPageReducer;

		dispatch({
			type: ActionTypes.SUBMIT_FAVORITE_DESTINATION_REQUEST,
			payload: {
				loading: true,
				loadingSubmit: true
			}
		});

		const body = {
			favorite_destination: {
				...fields
			}
		};

		const response = await API.favorite_destination.createFavoriteDestinations(body);

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.SUBMIT_FAVORITE_DESTINATION_ERROR,
				payload: {
					meta: response.meta,
					loading: false,
					loadingSubmit: false
				}
			});
		}

		const newFavoriteDestinations = response.data.favorite_destinations;

		dispatch({
			type: ActionTypes.SUBMIT_FAVORITE_DESTINATION_SUCCESS,
			payload: {
				favorite_destinations: newFavoriteDestinations,
				loading: false,
				loadingSubmit: false,
				meta: response.meta
			}
		});
	};
}

export function deleteFavoriteDestinationById(id) {
	return async dispatch => {
		dispatch({
			type: ActionTypes.DELETE_FAVORITE_DESTINATION_BY_ID_REQUEST,
			payload: {
				loading: true,
				loadingSubmit: true
			}
		});

		const response = await API.favorite_destination.deleteFavoriteDestinationsById(id);

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.DELETE_FAVORITE_DESTINATION_BY_ID_ERROR,
				payload: {
					meta: response.meta,
					loading: false,
					loadingSubmit: false
				}
			});
		}

		dispatch({
			type: ActionTypes.DELETE_FAVORITE_DESTINATION_BY_ID_SUCCESS,
			payload: {
				favorite_destinations: response.data.favorite_destinations,
				loading: false,
				loadingSubmit: false,
				meta: response.meta
			}
		});
	};
}

export function resetMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_FAVORITE_DESTIONATION_META
		});
	};
}

export function resetPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_FAVORITE_DESTIONATION_PAGE
		});
	};
}
